import { from } from 'rxjs'
import loginService, { getToken } from '../services/loginService'

export const backendUrl = '/api'

export const isLoggedIn = () => {
  return !!getToken()
}

const checkStatus = async res => {
  if (res.ok) {
    // res.status >= 200 && res.status < 300
    return res
  } else {
    if (res.status === 401) {
      // eslint-disable-next-line no-restricted-globals
      loginService.clearTokens()
      return
    }

    if (+res.headers.get('content-length')) {
      const body = await res.json()
      // eslint-disable-next-line no-throw-literal
      throw {
        body,
        status: res.status,
        toString: function () {
          // TODO make a clearer error interface with server
          return this.body.non_field_errors?.join(', ') || this.body.detail
        }
      }
    }

    // eslint-disable-next-line no-throw-literal
    throw {
      status: res.status,
      toString: function () {
        return this.status
      }
    }
  }
}

// For logging out unmark this (then remark to avoid keeping on loggin out)
// Note that due to chaning app navigator mechanism you will need to reopen the app
// after unmarking this
//localStorage.removeItem(tokenKey)

export const getHeaders = isPublic => {
  let headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
  if (isPublic) {
    return new Promise(resolve => {
      resolve(headers)
    })
  }

  const token = getToken()

  if (token) headers = { ...headers, Authorization: `JWT ${token}` }

  return new Promise(resolve => {
    resolve(headers)
  })
}

const sendWithBody = (path, bodyObj, method = 'POST', baseUrl = backendUrl) => {
  const body = JSON.stringify(bodyObj)
  const url = `${baseUrl ? baseUrl : backendUrl}${path}`

  return from(
    getHeaders()
      .then(headers => {
        return fetch(url, {
          headers,
          body,
          method
        })
      })
      .then(checkStatus)
      .then(res => {
        return +res.headers.get('content-length') ? res?.json() : res?.text()
      })
  )
}

export const postJSON = (path, bodyObj) => {
  return sendWithBody(path, bodyObj, 'POST')
}

export const putJSON = (path, bodyObj) => {
  return sendWithBody(path, bodyObj, 'PUT')
}

export const patchJSON = (path, bodyObj, baseUrl = backendUrl) => {
  return sendWithBody(path, bodyObj, 'PATCH', baseUrl)
}

export const getJSON = (path, baseUrl = backendUrl, isPublic = false) => {
  const url = `${baseUrl}${path}`
  return from(
    getHeaders(isPublic)
      .then(headers => {
        return fetch(url, {
          headers
        })
      })
      .then(checkStatus)
      .then(res => res.json())
  )
}

export const getLocaleFromLanguage = (language, languages) => {
  return languages?.[language]?.locale
}

export const getLanguageFromLocale = (locale, languages) => {
  if (!languages) return null
  return Object.keys(languages)?.find(key => languages[key]?.locale === locale)
}
